import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FormQuestions } from 'components/ClientForm/FormQuestions/FormQuestions';
import React from 'react';

import classes from './FormItem.module.scss';
import { FormQuestion, FormStatus } from 'types/FormsInvitation';

interface FormItemProps {
    formId: number;
    formName: string;
    status: FormStatus;
    isExpanded: boolean;
    questions?: FormQuestion[];
    answers?: { [questionId: number]: string | string[] };
    onToggle: () => void;
    onSave?: (formId: number, answers: { [questionId: number]: string | string[] }) => void;
}

export const FormItem: React.FC<FormItemProps> = props => {
    return (
        <div className={classes.root}>
            <button
                type="button"
                className={clsx(classes.header, {
                    [classes.headerExpanded]: props.isExpanded
                })}
                onClick={props.onToggle}
            >
                <span className={classes.name}>{props.formName}</span>
                <div className={classes.statusContainer}>
                    <span
                        className={`${classes.status} ${
                            props.status === FormStatus.Pending
                                ? classes.statusPending
                                : classes.statusCompleted
                        }`}
                    >
                        {props.status}
                    </span>
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={clsx(classes.chevron, {
                            [classes.chevronExpanded]: props.isExpanded
                        })}
                    />
                </div>
            </button>

            {props.questions && props.onSave && (
                <div
                    className={clsx(classes.panel, {
                        [classes.panelExpanded]: props.isExpanded
                    })}
                >
                    <FormQuestions
                        formId={props.formId}
                        questions={props.questions!}
                        answers={props.answers || {}}
                        onSave={props.onSave!}
                    />
                </div>
            )}
        </div>
    );
};
